import { Box, Radio, Typography } from '@mui/material';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import { FC } from 'react';
import { CLIENT_USER_ROLE } from '@api/types/client-user-management';

interface RoleCardProps {
  role: CLIENT_USER_ROLE;
  label: string;
  description: string;
  isSelected: boolean;
  onSelect: () => void;
}
const RoleCard: FC<RoleCardProps> = ({ role, label, description, isSelected, onSelect }) => {
  return (
    <Box
      onClick={onSelect}
      sx={{
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        border: isSelected ? '1px solid #2F736E' : '1px solid #737F86',
        backgroundColor: isSelected ? '#2F736E14' : '#FFFFFF',
        borderRadius: '0.5rem',
        padding: '0.75rem 0.5rem',
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '0.5rem',
        }}
      >
        <Radio
          checked={isSelected}
          value={role}
          onChange={onSelect}
          onClick={(e) => e.stopPropagation()}
          disableRipple
          icon={<RadioButtonUncheckedOutlinedIcon sx={{ fontSize: '1.25rem', color: '#737F86' }} />}
          checkedIcon={
            <RadioButtonCheckedOutlinedIcon sx={{ fontSize: '1.25rem', color: '#2F736E' }} />
          }
          sx={{
            p: 0,
            mt: '0.125rem',
            flexShrink: 0,
            color: '#737F86',
            '&.Mui-checked': {
              color: '#2F736E',
            },
          }}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: '0.875rem', fontWeight: 500, color: '#162936' }}>
            {label}
          </Typography>
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 500, color: '#6C6C6C' }}>
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RoleCard;
